import React from 'react';
const Dashboard = React.lazy(() => import('../views/Dashboard/dashboard'));

var indexRoutes = [{ path: "/", name: "Home", component: Dashboard }];

export default indexRoutes;
